import { render, staticRenderFns } from "./ipCount.vue?vue&type=template&id=1ad344cc&"
import script from "./ipCount.vue?vue&type=script&lang=js&"
export * from "./ipCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad344cc')) {
      api.createRecord('1ad344cc', component.options)
    } else {
      api.reload('1ad344cc', component.options)
    }
    module.hot.accept("./ipCount.vue?vue&type=template&id=1ad344cc&", function () {
      api.rerender('1ad344cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/ipCount.vue"
export default component.exports